import { useState, useEffect } from 'react';

/**
 * Hook to determine the maximum number of visible labels based on window width.
 * Uses a debounced resize listener to optimize performance and prevent rapid state updates.
 * 
 * @returns number - The maximum number of labels to display (4 for desktop, 3 for mobile)
 */
export function useMaxVisibleLabels(): number {
  const [max, setMax] = useState(window.innerWidth > 1024 ? 4 : 3);

  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout>;
    
    const handler = () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        setMax(window.innerWidth > 1024 ? 4 : 3);
      }, 150);
    };

    window.addEventListener('resize', handler);
    
    return () => { 
      window.removeEventListener('resize', handler); 
      clearTimeout(timeout);
    };
  }, []);

  return max;
}
